import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import FilterPanel from 'pages/mwdealcompare/FilterPanel'
import { useSelector } from 'react-redux'
import selectAolName from 'redux/selectors/selectAolName'

const Filters = ({ comparableParams, compareParams, short, query, pageToggleLeft }) => {
  const aol = useSelector(selectAolName)

  return (
    <div>
      <div className='bg-ghost-grey ph6'>
        <h2 className='b f4 black lh-title mv6'>
          Compare type
        </h2>
        <IconButton
          classes={{ root: 'dn-l bg-transparent db absolute top5 right5 shadow-none black hover-cadet-blue mr2' }}
          size='small'
          onClick={pageToggleLeft}
        >
          <CloseIcon />
        </IconButton>
      </div>
      <div className='ph6'>
        <div className='flex flex-column f6 bg-white pt4 ph6'>
          <FilterPanel
            label='Select parameters to compare'
            showReset
            {...{ query, short, aol, comparableParams, compareParams }}
          />
        </div>
      </div>
    </div>
  )
}

export default Filters
